<template>
  <div class="myinfo" >
    <div class="form-horizontal bind_tel_from">
      <div class="form-group row">
        <div class="col-md-12" style="height: 80px;font-size: 16px;">
          <p class="bind_tel_title" style="color: red">
            根据《移动互联网应用程序信息服务管理规定》，注册用户需要实名认证，请立即绑定手机号!
          </p>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 control-label">手机号</label>
        <div class="col-md-9">
          <input
              class="form-control"
              v-model="phone"
          />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-3 control-label">图形验证码</label>
        <div class="col-md-5">
          <input type="text" class="form-control" placeholder="请输入图形验证码" aria-describedby="basic-addon1" v-model="captcha" />
        </div>
        <div class="col-md-4">
          <!--          <button type="submit" class="btn btn-default form-control sub" @click="getRandomImage" v-if="!imageCode">获取验证码</button>-->
          <p style="margin-top: 10px;cursor: pointer;" @click="getRandomImage" v-if="!imageCode">点击获取</p>
          <img :src="imageCode" v-else @click="getRandomImage" />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-3 control-label">手机验证码</label>
        <div class="col-md-5">
          <input
              class="form-control border"
              v-model="phoneVerifyCode"
              placeholder="请输入手机验证码"
          />
        </div>
        <div class="col-md-4">
          <button type="button" class="btn-default form-control sub" @click="getSmsVerifyCode" :disabled="smsDisabled">
            {{ smsMessage }}
          </button>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-4 control-label">&nbsp;&nbsp;&nbsp;&nbsp;</label>
        <div class="col-md-8">
          <button type="button" class="btn btn-default" @click="bindTel">
            绑定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.bind_tel_from{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.bind_tel_title{
  position: absolute;
  left: 50%;
//top: 50%;
//transform: translate(-50%,-50%);
  transform: translate(-50%);
}
</style>

<script>

export default {
  name: 'BindTel',
  props: ['bindTelRandomNumber'],
  data: function () {
    return {
      userInfo: null,
      randomCode: null,
      imageCode: `/static/images/checkcode.png`,
      phone: '',
      captcha: '',
      phoneVerifyCode: '',
      smsDisabled: false,
      smsMessage: `获取短信验证码`
    }
  },
  created() {
  },
  computed: {
  },
  mounted() {
    const number = parseInt(Math.random(1) * Math.pow(10, 10))
    this.randomCode = number
    this.getRandomImage()

    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))

    // 清除浏览器本地存储, 防止尚未绑定手机号的学生通过url访问
    // localStorage.clear()
  },
  methods: {
    // 获取图形验证码
    getRandomImage() {
      this.axios.get(`/sys/randomImage/${this.randomCode}`).then((res) => {
        this.imageCode = res.result
      })
    },

    // 获取短信验证码
    getSmsVerifyCode() {
      if (!this.captcha) {
        this.$message.warning('请输入图形验证码')
        return
      }
      if (!this.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      this.countdown(15)
      this.axios
        .get(`/biz/user/phone/verify/code`, {
          params: {
            captcha: this.captcha,
            checkKey: this.randomCode,
            mobile: this.phone
          }
        })
        .then((res) => {
          if (res.success) {
            this.$message.success('发送成功')
            this.countdown(15)
          } else {
            this.getRandomImage()
          }
        })
        .catch(() => {
          this.getRandomImage()
        })
    },

    // 绑定手机号
    bindTel() {
      if (!this.captcha) {
        this.$message.warning('请输入图形验证码')
        return
      }
      if (!this.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!this.phoneVerifyCode) {
        this.$message.warning('请输入短信验证码')
        return
      }
      this.axios
        .get(`/biz/user/phone/bind2`, {
          params: {
            mobile: this.phone,
            // captcha: this.captcha,
            code: this.phoneVerifyCode,
            bindTelRandomNumber: this.bindTelRandomNumber
          }
        })
        .then((res) => {
          this.$message.success('修改成功')

          // 跳转到登录
          setTimeout(() => {
            this.common.toURL('/login')
            // this.$router.replace('/login')
          }, 1000)
        })
        .catch((err) => {
          console.log(err)
        })
    },

    // 倒计时
    countdown(index) {
      let countdownData = index
      this.smsDisabled = true

      if (this.timer) {
        clearInterval(this.timer)
      }

      this.timer = setInterval(() => {
        if (countdownData >= 0) {
          this.smsMessage = `${countdownData}秒后重试`
          countdownData--
        } else {
          this.smsMessage = `获取短信验证码`
          this.smsDisabled = false
          clearInterval(this.timer)
        }
      }, 1000)
    }

  } // methods end
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.border-none {
  border: 0;
}

input {
  border: 1px solid #f2f2f2;
}

.myinfo {
  .row {
    width: 500px;
    margin: 0 auto;
  }

  background: #f6fffb;
  padding: 28px;
  //min-height:640px;
  margin-top: 200px;
  margin-left: 20px;
  margin-right: 28px;

  .col-md-4 {
    padding-right: 0;
  }

  label {
    margin-top: 10px;
    color: #999;
  }

  h1 {
    border-bottom: 1px solid #efefef;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .btn {
    background: $bgColor;
    color: #fff;
    width: 80px;
  }

  .form-group {
    margin-bottom: 20px;
  }

  .form-horizontal{
    background:#fff;
    padding:28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/findpwd/components/BindTel.vue